module.exports = __webpack_public_path__ + "static/media/login-google-logo.f7432012.png";